// extracted by mini-css-extract-plugin
export var author = "Author-module--author--1c58d";
export var bio = "Author-module--bio--08950";
export var twitter = "Author-module--twitter--90647";